export const menuConstants = {
  leftMenu: [
    {
      label: 'Dashboard',
      icon: 'fa-solid fa-gauge',
      path: '/dashboard',
      location: 'top',
      subPath: true
    },
    {
      label: 'Campaigns',
      icon: 'fa-solid fa-bullhorn',
      path: '/campaigns',
      location: 'top',
      subPath: true
    },
    {
      label: 'Templates',
      icon: 'fa-solid fa-file-code',
      path: '/templates',
      location: 'top',
      subPath: true
    },
    {
      label: 'Audiences',
      icon: 'fa-solid fa-users',
      path: '/audiences',
      location: 'top',
      subPath: true
    },
    {
      label: 'Accounts',
      icon: 'fa-solid fa-screwdriver-wrench',
      path: '/accounts',
      location: 'top',
      subPath: true
    },
    {
      label: 'Settings',
      icon: 'fa-solid fa-sliders',
      path: '/settings',
      location: 'top',
      subPath: true
    },
    {
      label: 'Organizations',
      icon: 'fa-solid fa-layer-group',
      path: 'organizations',
      location: 'bottom'
    }
  ]
}
